import RpcClass from "../../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import FormFieldConfig from "../../../../../../../server/com/silkplm/engine/forms/schema/definition/FormFieldConfig.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.engine.forms.schema.definition.SelectFormFieldConfig';

import LocalDate from "../../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../../server/LocalTime.js";



class SelectFormFieldConfig extends FormFieldConfig {

    /**
     *  @class SelectFormFieldConfig
     *  @alias module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig
     *  
     * */
    constructor(){
        super();

        /** @type {string[]}  */
        this.additionalRestrictions = null;
        /** @type {boolean}  */
        this.allowNull = null;
        /** @type {string}  */
        this.allowNullErrorMessage = null;
        /** @type {boolean}  */
        this.alwaysShowInCloneActivity = null;
        /** @type {boolean}  */
        this.apiCanSkipReadOnly = null;
        /** @type {boolean}  */
        this.atomicCompare = null;
        /** @type {boolean}  */
        this.autoValidateOnFormLoading = null;
        /** @type {boolean}  */
        this.autofocus = null;
        /** @type {boolean}  */
        this.autosave = null;
        /** @type {string}  */
        this.cacheOnAttribute = null;
        /** @type {boolean}  */
        this.canListForeignItems = null;
        /** @type {string[]}  */
        this.childrenFields = null;
        /** @type {string}  */
        this.clientValidation = null;
        /** @type {boolean}  */
        this.cloneFieldExcluded = null;
        /** @type {number}  */
        this.colMultiRows = null;
        /** @type {string}  */
        this.comparatorFunction = null;
        /** @type {boolean}  */
        this.computed = null;
        /** @type {string}  */
        this.computedStreamingQuery = null;
        /** @type {boolean}  */
        this.databaseRequiredField = null;
        /** @type {string}  */
        this.defaultValue = null;
        /** @type {boolean}  */
        this.defaultVisible = null;
        /** @type {boolean}  */
        this.docked = null;
        /** @type {boolean}  */
        this.emptyExcludedFromUnique = null;
        /** @type {boolean}  */
        this.enableBulkEdit = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.enabledByFeatureFlags = null;
        /** @type {boolean}  */
        this.enabledConfiguration = null;
        /** @type {boolean}  */
        this.enabledFilters = null;
        /** @type {boolean}  */
        this.enabledStyles = null;
        /** @type {boolean}  */
        this.entityLabel = null;
        /** @type {boolean}  */
        this.excludeFieldInPrintouts = null;
        /** @type {*}  */
        this.expectedFilterSpecClass = null;
        /** @type {boolean}  */
        this.exportField = null;
        /** @type {string}  */
        this.exportLabel = null;
        /** @type {string}  */
        this.fieldConfigId = null;
        /** @type {string}  */
        this.fieldLabel = null;
        /** @type {string}  */
        this.fieldLabelInConfiguration = null;
        /** @type {string}  */
        this.fieldName = null;
        /** @type {string}  */
        this.fieldValidationFunctionName = null;
        /** @type {boolean}  */
        this.filterDisabled = null;
        /** @type {string}  */
        this.filterRenderer = null;
        /** @type {string}  */
        this.filterToStringFunction = null;
        /** @type {boolean}  */
        this.filterable = null;
        /** @type {string}  */
        this.filteringFieldByParent = null;
        /** @type {string}  */
        this.foreignClass = null;
        /** @type {*}  */
        this.foreignFilterClass = null;
        /** @type {string}  */
        this.formColFlexCss = null;
        /** @type {boolean}  */
        this.formDisabled = null;
        /** @type {boolean}  */
        this.formDisabledInEdit = null;
        /** @type {boolean}  */
        this.formDisabledInEmbedded = null;
        /** @type {boolean}  */
        this.formDisabledInNew = null;
        /** @type {number}  */
        this.formOrder = null;
        /** @type {string}  */
        this.formPlaceholder = null;
        /** @type {boolean}  */
        this.freezeLockedUpdateOnUserEdit = null;
        /** @type {string}  */
        this.freezeOnField = null;
        /** @type {boolean}  */
        this.gridColAutosize = null;
        /** @type {boolean}  */
        this.gridColDisabled = null;
        /** @type {boolean}  */
        this.gridColEditable = null;
        /** @type {string}  */
        this.gridColLabel = null;
        /** @type {number}  */
        this.gridColOrder = null;
        /** @type {boolean}  */
        this.gridColSearchable = null;
        /** @type {number}  */
        this.gridColSize = null;
        /** @type {boolean}  */
        this.gridColSortable = null;
        /** @type {string}  */
        this.gridColTemplate = null;
        /** @type {string}  */
        this.gridColTemplateComponent = null;
        /** @type {boolean}  */
        this.gridColVisible = null;
        /** @type {*}  */
        this.gridLinkClassNavigator = null;
        /** @type {string}  */
        this.gridToStringFunction = null;
        /** @type {boolean}  */
        this.hasContextFilter = null;
        /** @type {boolean}  */
        this.hasFilter = null;
        /** @type {boolean}  */
        this.hasGridLink = null;
        /** @type {string}  */
        this.helpWindowTitle = null;
        /** @type {Object.<string, string>}  */
        this.helpWindowTitleTr = null;
        /** @type {string}  */
        this.hexColor = null;
        /** @type {boolean}  */
        this.hidden = null;
        /** @type {string}  */
        this.htmlHelpText = null;
        /** @type {Object.<string, string>}  */
        this.htmlHelpTextTr = null;
        /** @type {string}  */
        this.htmlHint = null;
        /** @type {Object.<string, string>}  */
        this.htmlHintTr = null;
        /** @type {boolean}  */
        this.ignoreFilterOnGridFilters = null;
        /** @type {boolean}  */
        this.ignoreFilterOnGridFilters = null;
        /** @type {boolean}  */
        this.inUniqueConstraint = null;
        /** @type {boolean}  */
        this.isDynamic = null;
        /** @type {boolean}  */
        this.isForeignKey = null;
        /** @type {boolean}  */
        this.joined = null;
        /** @type {string}  */
        this.joinedFieldPath = null;
        /** @type {boolean}  */
        this.joinedTranslations = null;
        /** @type {string}  */
        this.minValueInConfiguration = null;
        /** @type {string}  */
        this.onChangeFunction = null;
        /** @type {string}  */
        this.onGridShowAsField = null;
        /** @type {Object.<*, *>}  */
        this.options = null;
        /** @type {Object.<string, *>[]}  */
        this.optionsList = null;
        /** @type {string}  */
        this.optionsType = null;
        /** @type {string}  */
        this.parentField = null;
        /** @type {number}  */
        this.partOfEntityLabel = null;
        /** @type {string}  */
        this.propNameToNavigateGridLink = null;
        /** @type {boolean}  */
        this.providerIsStatic = null;
        /** @type {boolean}  */
        this.readOnly = null;
        /** @type {boolean}  */
        this.readOnlyActiveInCompanyConfiguration = null;
        /** @type {string}  */
        this.readOnlyFunction = null;
        /** @type {boolean}  */
        this.readOnlyInEdit = null;
        /** @type {string}  */
        this.realFieldName = null;
        /** @type {string}  */
        this.renderer = null;
        /** @type {string}  */
        this.rendererOptions = null;
        /** @type {string}  */
        this.rendererSize = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig}  */
        this.securedFieldConfig = null;
        /** @type {string}  */
        this.shortHelpText = null;
        /** @type {Object.<string, string>}  */
        this.shortHelpTextTr = null;
        /** @type {boolean}  */
        this.showAddInSelect = null;
        /** @type {boolean}  */
        this.showInExport = null;
        /** @type {string}  */
        this.sourceClass = null;
        /** @type {string}  */
        this.styleFunction = null;
        /** @type {string}  */
        this.toStringFunction = null;
        /** @type {boolean}  */
        this.translations = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/TreeConfig.TreeConfig}  */
        this.treeConfig = null;
        /** @type {string}  */
        this.type = null;
        /** @type {string}  */
        this.typeOfSortOfColumn = null;
        /** @type {string}  */
        this.viewClassShortId = null;
        /** @type {string}  */
        this.visibleFunction = null;
        /** @type {boolean}  */
        this.whiteBackgroundStyleColumnInExcel = null;

    }





    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAdditionalRestrictions(val){
        this.additionalRestrictions = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAllowNull(val){
        this.allowNull = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAllowNullErrorMessage(val){
        this.allowNullErrorMessage = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAlwaysShowInCloneActivity(val){
        this.alwaysShowInCloneActivity = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withApiCanSkipReadOnly(val){
        this.apiCanSkipReadOnly = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAtomicCompare(val){
        this.atomicCompare = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAutoValidateOnFormLoading(val){
        this.autoValidateOnFormLoading = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAutofocus(val){
        this.autofocus = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withAutosave(val){
        this.autosave = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withCacheOnAttribute(val){
        this.cacheOnAttribute = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withCanListForeignItems(val){
        this.canListForeignItems = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withChildrenFields(val){
        this.childrenFields = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withClientValidation(val){
        this.clientValidation = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withCloneFieldExcluded(val){
        this.cloneFieldExcluded = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withColMultiRows(val){
        this.colMultiRows = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withComparatorFunction(val){
        this.comparatorFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withComputed(val){
        this.computed = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withComputedStreamingQuery(val){
        this.computedStreamingQuery = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withDatabaseRequiredField(val){
        this.databaseRequiredField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withDefaultValue(val){
        this.defaultValue = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withDefaultVisible(val){
        this.defaultVisible = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withDocked(val){
        this.docked = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEmptyExcludedFromUnique(val){
        this.emptyExcludedFromUnique = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEnableBulkEdit(val){
        this.enableBulkEdit = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEnabledByFeatureFlags(val){
        this.enabledByFeatureFlags = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEnabledConfiguration(val){
        this.enabledConfiguration = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEnabledFilters(val){
        this.enabledFilters = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEnabledStyles(val){
        this.enabledStyles = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withEntityLabel(val){
        this.entityLabel = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withExcludeFieldInPrintouts(val){
        this.excludeFieldInPrintouts = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withExpectedFilterSpecClass(val){
        this.expectedFilterSpecClass = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withExportField(val){
        this.exportField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withExportLabel(val){
        this.exportLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFieldConfigId(val){
        this.fieldConfigId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFieldLabel(val){
        this.fieldLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFieldLabelInConfiguration(val){
        this.fieldLabelInConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFieldName(val){
        this.fieldName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFieldValidationFunctionName(val){
        this.fieldValidationFunctionName = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFilterDisabled(val){
        this.filterDisabled = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFilterRenderer(val){
        this.filterRenderer = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFilterToStringFunction(val){
        this.filterToStringFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFilterable(val){
        this.filterable = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFilteringFieldByParent(val){
        this.filteringFieldByParent = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withForeignClass(val){
        this.foreignClass = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withForeignFilterClass(val){
        this.foreignFilterClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormColFlexCss(val){
        this.formColFlexCss = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormDisabled(val){
        this.formDisabled = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormDisabledInEdit(val){
        this.formDisabledInEdit = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormDisabledInEmbedded(val){
        this.formDisabledInEmbedded = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormDisabledInNew(val){
        this.formDisabledInNew = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormOrder(val){
        this.formOrder = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFormPlaceholder(val){
        this.formPlaceholder = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFreezeLockedUpdateOnUserEdit(val){
        this.freezeLockedUpdateOnUserEdit = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withFreezeOnField(val){
        this.freezeOnField = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColAutosize(val){
        this.gridColAutosize = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColDisabled(val){
        this.gridColDisabled = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColEditable(val){
        this.gridColEditable = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColLabel(val){
        this.gridColLabel = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColOrder(val){
        this.gridColOrder = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColSearchable(val){
        this.gridColSearchable = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColSize(val){
        this.gridColSize = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColSortable(val){
        this.gridColSortable = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColTemplate(val){
        this.gridColTemplate = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColTemplateComponent(val){
        this.gridColTemplateComponent = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridColVisible(val){
        this.gridColVisible = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridLinkClassNavigator(val){
        this.gridLinkClassNavigator = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withGridToStringFunction(val){
        this.gridToStringFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHasContextFilter(val){
        this.hasContextFilter = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHasFilter(val){
        this.hasFilter = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHasGridLink(val){
        this.hasGridLink = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHelpWindowTitle(val){
        this.helpWindowTitle = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHelpWindowTitleTr(val){
        this.helpWindowTitleTr = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHexColor(val){
        this.hexColor = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHidden(val){
        this.hidden = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHtmlHelpText(val){
        this.htmlHelpText = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHtmlHelpTextTr(val){
        this.htmlHelpTextTr = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHtmlHint(val){
        this.htmlHint = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withHtmlHintTr(val){
        this.htmlHintTr = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withIgnoreFilterOnGridFilters(val){
        this.ignoreFilterOnGridFilters = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withIgnoreFilterOnGridFilters(val){
        this.ignoreFilterOnGridFilters = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withInUniqueConstraint(val){
        this.inUniqueConstraint = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withIsDynamic(val){
        this.isDynamic = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withIsForeignKey(val){
        this.isForeignKey = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withJoined(val){
        this.joined = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withJoinedFieldPath(val){
        this.joinedFieldPath = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withJoinedTranslations(val){
        this.joinedTranslations = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withMinValueInConfiguration(val){
        this.minValueInConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withOnChangeFunction(val){
        this.onChangeFunction = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withOnGridShowAsField(val){
        this.onGridShowAsField = val;
        return this;
    };


    /**
     * @param val {Object.<*, *>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withOptions(val){
        this.options = val;
        return this;
    };


    /**
     * @param val {Object.<string, *>[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withOptionsList(val){
        this.optionsList = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withOptionsType(val){
        this.optionsType = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withParentField(val){
        this.parentField = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withPartOfEntityLabel(val){
        this.partOfEntityLabel = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withPropNameToNavigateGridLink(val){
        this.propNameToNavigateGridLink = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withProviderIsStatic(val){
        this.providerIsStatic = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withReadOnly(val){
        this.readOnly = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withReadOnlyActiveInCompanyConfiguration(val){
        this.readOnlyActiveInCompanyConfiguration = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withReadOnlyFunction(val){
        this.readOnlyFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withReadOnlyInEdit(val){
        this.readOnlyInEdit = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withRealFieldName(val){
        this.realFieldName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withRenderer(val){
        this.renderer = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withRendererOptions(val){
        this.rendererOptions = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withRendererSize(val){
        this.rendererSize = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withSecuredFieldConfig(val){
        this.securedFieldConfig = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withShortHelpText(val){
        this.shortHelpText = val;
        return this;
    };


    /**
     * @param val {Object.<string, string>}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withShortHelpTextTr(val){
        this.shortHelpTextTr = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withShowAddInSelect(val){
        this.showAddInSelect = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withShowInExport(val){
        this.showInExport = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withSourceClass(val){
        this.sourceClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withStyleFunction(val){
        this.styleFunction = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withToStringFunction(val){
        this.toStringFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withTranslations(val){
        this.translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/TreeConfig.TreeConfig}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withTreeConfig(val){
        this.treeConfig = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withType(val){
        this.type = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withTypeOfSortOfColumn(val){
        this.typeOfSortOfColumn = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withViewClassShortId(val){
        this.viewClassShortId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withVisibleFunction(val){
        this.visibleFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig.SelectFormFieldConfig}
     */
    withWhiteBackgroundStyleColumnInExcel(val){
        this.whiteBackgroundStyleColumnInExcel = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['additionalRestrictions'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['allowNull'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['allowNullErrorMessage'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['alwaysShowInCloneActivity'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['apiCanSkipReadOnly'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['atomicCompare'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['autoValidateOnFormLoading'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['autofocus'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['autosave'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cacheOnAttribute'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['canListForeignItems'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['childrenFields'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['clientValidation'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['cloneFieldExcluded'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['colMultiRows'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['comparatorFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computed'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['computedStreamingQuery'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['databaseRequiredField'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['defaultValue'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['defaultVisible'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['docked'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['emptyExcludedFromUnique'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enableBulkEdit'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledByFeatureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['enabledConfiguration'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledFilters'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['enabledStyles'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['entityLabel'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['excludeFieldInPrintouts'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['expectedFilterSpecClass'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['exportField'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['exportLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldConfigId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldLabelInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['fieldValidationFunctionName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['filterDisabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['filterRenderer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['filterToStringFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['filterable'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['filteringFieldByParent'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['foreignClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['foreignFilterClass'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['formColFlexCss'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['formDisabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formDisabledInEdit'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formDisabledInEmbedded'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formDisabledInNew'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['formOrder'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['formPlaceholder'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['freezeLockedUpdateOnUserEdit'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['freezeOnField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gridColAutosize'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridColDisabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridColEditable'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridColLabel'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gridColOrder'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['gridColSearchable'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridColSize'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['gridColSortable'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridColTemplate'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gridColTemplateComponent'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['gridColVisible'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['gridLinkClassNavigator'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};
metadata['gridToStringFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['hasContextFilter'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasFilter'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['hasGridLink'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['helpWindowTitle'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['helpWindowTitleTr'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['hexColor'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['htmlHelpText'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['htmlHelpTextTr'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['htmlHint'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['htmlHintTr'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['ignoreFilterOnGridFilters'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['ignoreFilterOnGridFilters'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['inUniqueConstraint'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isDynamic'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isForeignKey'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['joined'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['joinedFieldPath'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['joinedTranslations'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['minValueInConfiguration'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['onChangeFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['onGridShowAsField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['options'] = {'remoteType' : 'Object.<*, *>', 'jsType' : 'Object.<*, *>', 'mapped' : 'false'};
metadata['optionsList'] = {'remoteType' : 'Object.<string, *>[]', 'jsType' : 'Object.<string, *>[]', 'mapped' : 'false'};
metadata['optionsType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['parentField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['partOfEntityLabel'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['propNameToNavigateGridLink'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['providerIsStatic'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['readOnly'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['readOnlyActiveInCompanyConfiguration'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['readOnlyFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['readOnlyInEdit'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['realFieldName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['renderer'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rendererOptions'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rendererSize'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['securedFieldConfig'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig.SecuredFieldConfig', 'mapped' : 'false'};
metadata['shortHelpText'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shortHelpTextTr'] = {'remoteType' : 'Object.<string, string>', 'jsType' : 'Object.<string, string>', 'mapped' : 'false'};
metadata['showAddInSelect'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showInExport'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['sourceClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['styleFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['toStringFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['translations'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['treeConfig'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/TreeConfig.TreeConfig', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/TreeConfig.TreeConfig', 'mapped' : 'false'};
metadata['type'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['typeOfSortOfColumn'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['viewClassShortId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['visibleFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['whiteBackgroundStyleColumnInExcel'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.forms.schema.definition.SelectFormFieldConfig';
metadata.__type_short__ = 'SelectFormFieldConfig';
SelectFormFieldConfig.prototype.__metadata__ = metadata;

SelectFormFieldConfig.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig */
export default SelectFormFieldConfig

export { SelectFormFieldConfig }
